import BreadCrumbs from 'components/breadcrumbs'
import PMBPagination from 'components/PMBPagination'
import { TableComponent as DataTable } from 'components/TableComponent'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, CardText } from 'reactstrap'
import { setFetchOption, toggleModalDelete } from './eventParticipantSlice'
import CustomButton from 'components/Buttons/CustomButton'
import {
  URL_EVENT,
  URL_EVENT_PARTICIPANT_FORM,
  URL_EVENT_TIMELINE,
} from 'utils/pathUrl'
import { useLocation, useNavigate } from 'react-router-dom'
import { useFetchEventParticipantQuery } from './eventParticipantApiSlice'
import { ResponsiveActionButton } from 'components/Buttons'
import { Can } from 'context/Acl'
import { BUSINESS_EVENT_PARTICIPANT, MANAGE } from 'utils/subjectActions'
import { useState } from 'react'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import { useDebounce } from 'helpers'
import ModalDelete from './ModalDelete'
import { ExternalLink } from 'react-feather'
import { useFetchUtilsEventQuery } from '../event/eventApiSlice'

const ListEventParticipant = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const dataState = location.state
  const queryParams = new URLSearchParams(location.search)
  const id = queryParams.get('id')
  const [selectedRow, setSelectedRow] = useState(null)
  const [searchInput, setSearchInput] = useState('')
  const { tag, isOpenModalDelete } = useSelector((s) => s.eventParticipant)
  const resUtils = useFetchUtilsEventQuery()
  const res = useFetchEventParticipantQuery(
    {
      ...tag,
      id: id,
    },
    { skip: !tag },
  )

  const columns = [
    {
      name: <span>Nama</span>,
      selector: (row) => row.name,
      grow: 2,
      // sortField: 'name',
      // sortable: true,
      cell: (row) => <div data-testid={`event-participant-row-${row.id}`}>{row?.name}</div>,
    },
    {
      name: <span>Catatan</span>,
      selector: (row) => row.note,
      grow: 2,
      // sortField: 'note',
      // sortable: true,
      cell: (row) => <div>{row?.note}</div>,
    },
    // {
    //   name: <span>Status</span>,
    //   selector: (row) => row.status,
    //   grow: 2,
    //   sortable: true,
    //   cell: (row) => {
    //     if (!row.status || !resUtils?.data?.eventParticipantStatus) return null

    //     // Cari label dari API sesuai value status
    //     const statusObj = resUtils.data.eventParticipantStatus.find(
    //       (s) => s.value.toLowerCase() === row.status.toLowerCase(),
    //     )

    //     const label = statusObj ? statusObj.label : row.status

    //     const badgeColors = {
    //       registered: { bg: 'bg-success-50', text: 'text-success' },
    //       attended: { bg: 'bg-primary-50', text: 'text-primary' },
    //       cancelled: { bg: 'bg-danger-50', text: 'text-danger-700' },
    //       finished: { bg: 'bg-success-50', text: 'text-success' },
    //     }

    //     const colors = badgeColors[row.status.toLowerCase()] || {
    //       bg: 'bg-gray-100',
    //       text: 'text-gray-700',
    //     }

    //     return (
    //       <div
    //         className={`badge rounded-pill ${colors.bg} ${colors.text} px-2 py-1 flex-centered gap-1`}
    //         style={{
    //           whiteSpace: 'normal',
    //           wordBreak: 'break-word',
    //           textAlign: 'center',
    //           maxWidth: '100%',
    //         }}
    //       >
    //         {label}
    //       </div>
    //     )
    //   },
    // },

    // {
    //   name: <span>Sertifikat</span>,
    //   selector: (row) => row.certificateNumber,
    //   grow: 2,
    //   // sortField: 'certificateNumber',
    //   sortable: true,
    //   cell: (row) => (
    //     <div className="d-flex gap-2">
    //       {row?.certificateNumber ?? '-'}
    //       {row?.certificateUrl && (
    //         <span className="text-primary pointer">
    //           <ExternalLink
    //             size={12}
    //             onClick={() => {
    //               window.open(row?.certificateUrl, '_blank')
    //             }}
    //           />
    //         </span>
    //       )}
    //     </div>
    //   ),
    // },
    {
      name: '',
      grow: 1,
      cell: (row) => (
        <>
          <Can I={MANAGE} this={BUSINESS_EVENT_PARTICIPANT}>
            <ResponsiveActionButton
              iconName="edit"
              label="Ubah"
              onClick={() => {
                navigate(URL_EVENT_PARTICIPANT_FORM, {
                  state: {
                    ...dataState,
                    ...row,
                    eventId: dataState?.id ?? id,
                    typeAction: 'edit',
                  },
                })
              }}
              testId={`event-participant-edit-${row.id}`}
            />
            <ResponsiveActionButton
              iconName="trash"
              iconColor={'#B42318'}
              label="Hapus"
              onClick={() => {
                setSelectedRow(row)
                dispatch(toggleModalDelete())
              }}
              testId={`event-participant-delete-${row.id}`}
            />
          </Can>
        </>
      ),
    },
  ]

  const handleSort = (column, direction) => {
    dispatch(
      setFetchOption({
        sortby: column.sortField,
        sortdir: direction === 'asc' ? 'desc' : 'asc',
      }),
    )
  }

  const debouncedSearch = useDebounce((value) => {
    dispatch(
      setFetchOption({
        page: 0,
        search: value,
      }),
    )
  }, 600)

  const onHandleSearchChange = (value) => {
    setSearchInput(value ?? '')
    debouncedSearch(value ?? '')
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' && tag?.s.length === 0) {
      e.preventDefault()
    }
  }

  return (
    <div className="w-100 px-3 pb-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs
          breadCrumbActive={`Peserta Event ${dataState?.title ?? res?.data?.items[0]?.title}`}
          breadCrumbParent={'Event'}
          breadCrumbParentOnClick={() => navigate(URL_EVENT)}
        />
      </div>
      <ModalDelete
        row={{ ...selectedRow, eventId: id }}
        isOpen={isOpenModalDelete}
        toggle={() => dispatch(toggleModalDelete())}
        refetch={res?.refetch}
      />
      <Card className="border-0 shadow-sm">
        <CardBody>
          <DataTable
            columns={columns}
            data={res?.data?.items}
            progressPending={res?.isLoading || res?.status === 'pending'}
            responsive
            persistTableHead
            defaultSortFieldId={1}
            defaultSortAsc={false}
            sortServer
            onSort={handleSort}
            pagination
            paginationServer
            paginationComponent={(props) => (
              <PMBPagination
                rowCount={res?.data?.totalItems}
                currentPage={tag?.page}
                rowsPerPage={tag?.size ?? 10}
                setCurrentPage={(e) => {
                  dispatch(setFetchOption({ page: e }))
                }}
                setRowsPerPage={(e) => {
                  dispatch(setFetchOption({ size: e }))
                }}
                props={props}
                testId="event-participant-pagination"
              />
            )}
            subHeader={true}
            subHeaderComponent={
              <div className="mb-3 w-100">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center w-100 mb-2">
                  <CardText tag="h5">
                    {'Peserta Event '}
                    {dataState?.title ?? res?.data?.items[0]?.title}
                  </CardText>

                  <Can I={MANAGE} this={BUSINESS_EVENT_PARTICIPANT}>
                    <CustomButton
                      onClick={() => {
                        navigate(URL_EVENT_PARTICIPANT_FORM, {
                          state: {
                            ...dataState,
                            eventId: dataState?.id ?? id,
                            typeAction: 'add',
                          },
                        })
                      }}
                      size="sm"
                      color="primary"
                      testId="event-participant-add-button"
                    >
                      + Tambah Peserta Event
                    </CustomButton>
                  </Can>
                </div>

                <div className="d-flex w-100">
                  <PMBSearchInputGroup
                    label="Cari"
                    value={searchInput}
                    placeholder="Cari..."
                    onChange={(e) => onHandleSearchChange(e.target.value)}
                    maxWidth="100%"
                    onKeyDown={handleKeyDown}
                    testId="event-participant-search-input"
                  />
                </div>
              </div>
            }
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default ListEventParticipant
